import { render, staticRenderFns } from "./DailySummary.vue?vue&type=template&id=150cf3f2&"
import script from "./DailySummary.vue?vue&type=script&lang=js&"
export * from "./DailySummary.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/cschwan/nextcloud/workspace/server/apps-extra/activity/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('150cf3f2')) {
      api.createRecord('150cf3f2', component.options)
    } else {
      api.reload('150cf3f2', component.options)
    }
    module.hot.accept("./DailySummary.vue?vue&type=template&id=150cf3f2&", function () {
      api.rerender('150cf3f2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/DailySummary.vue"
export default component.exports